import { render } from "./devMode.vue?vue&type=template&id=5623f24a"
import script from "./devMode.vue?vue&type=script&lang=js"
export * from "./devMode.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__